import React from 'react'
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup, LayersControl, LayerGroup } from 'react-leaflet'
import L from "leaflet";
import { minutesToHuman } from '../../../../../helpers/converters';
import './Map.css'

import { GeoJSON } from 'react-leaflet/GeoJSON'

const coordsCenterOfPoland = [52.138, 13.359]

export default function Map(props) {
  const { trails, companies } = props;

  const icon = L.icon({
    iconUrl: '/images/vendor/leaflet/dist/marker-icon.png',
    // iconUrl: '/images/location-pin.png',
    // shadowUrl: '',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
  })
  const iconCompany = L.icon({
    iconUrl: '/images/vendor/leaflet/dist/marker-icon-company.png',
    iconSize: [21, 34],
    iconAnchor: [10, 34],
  })

  return (
    <div className='searchMap-map-container'>
      <MapContainer
        center={coordsCenterOfPoland}
        zoom={6}
        scrollWheelZoom
        className='searchMap-map'
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <LayersControl position="topright">
          <LayersControl.Overlay checked name="Trasy">
            <LayerGroup>
              {trails.filter(t => t.startCoordinates).map(trail => (
                <Marker
                  key={trail.id}
                  position={trail.startCoordinates.split("/")}
                  icon={icon}
                >
                  <Popup>
                    <p>
                      Trasa: <b>{trail.title}</b><br/>
                      Czas: <b>{minutesToHuman(trail.tripTimeMinutes)}</b>
                    </p>
                    <a href={`/firmy/${trail.company.slug}/trasy/${trail.slug}`} target='_blank' className="btn btn-primary btn-sm">
                      {trail.active ? 'Rezerwuj' : 'Zobacz'}
                    </a>
                  </Popup>
                </Marker>
              ))}
            </LayerGroup>
          </LayersControl.Overlay>

          <LayersControl.Overlay checked name="Firmy">
            <LayerGroup>
              {companies.filter(c => c.coordinates).map(company => (
                <Marker
                  key={company.id}
                  position={company.coordinates.split("/")}
                  icon={iconCompany}
                >
                  <Popup>
                    <p>
                      Firma: <b>{company.title}</b><br/>
                      {/* Czas: <b>{minutesToHuman(trail.tripTimeMinutes)}</b> */}
                    </p>
                    <a href={`/firmy/${company.slug}`} target='_blank' className="btn btn-primary btn-sm">
                      Zobacz
                    </a>
                  </Popup>
                </Marker>
              ))} 
            </LayerGroup>
          </LayersControl.Overlay>
        </LayersControl>

        {/* <GeoJSON data={{
          "type":"Feature",
          // "id":"01",
          // "properties": {"name":"Alabama","density": 94.65},
          "geometry": {
            "type":"MultiLineString",
            "coordinates":[[
              [50.37962 - 28,23.25445 + 28],[49.56073 - 28,22.21726 + 28]
            ]]
          }
        }}
        style={() => ({ weigth: 1, color: 'blue' })} /> */}

      </MapContainer>
    </div>
  )
}